import * as angular from 'angular';
import {IQService, IWindowService} from 'angular';
import * as _ from "lodash";
import {FulfillmentSubTypeType} from "../types/fulfillment-sub-type.type";
import {LocationType} from "../../commons/types/location.type";
import {AttemptStatusType} from "../types/attemptStatus.type";
import {SplitService} from "../../commons/services/split-service.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {FulfillmentAlertsService} from "./fulfillment-alerts.service";
import {FulfillmentRequestsService} from "./fulfillment-requests.service";
import {FulfillmentStepModel} from "../models/fulfillment-step.model";

export class FulfillmentService {

  public attemptStatusType: typeof AttemptStatusType = AttemptStatusType;
  public cancelTokens: any = {};

  constructor(private fulfillmentRequestsService: FulfillmentRequestsService, private bringozLoaderService: BringozLoaderService, private $log,
              private fulfillmentAlertsService: FulfillmentAlertsService, private $q: IQService,
              private FulfillmentConstants, private splitService: SplitService, private $state, private $window: IWindowService) {
  }

  getStepAttemptInfo(fulfillmentId: string, stepId: string, referenceId: string, fulfillmentSubType: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.getStepAttemptInfo(fulfillmentId, stepId, referenceId, fulfillmentSubType)
      .then((response) => {
        deferred.resolve(response);
      })
      .catch((error) => {
        this.$log.error('Failed to get step attempt info', error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }

  getFulfillment(fulfillmentId, expand) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.getFulfillment(fulfillmentId, expand)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise

  }

  getFulfillmentStepDefaultBranches(fulfillmentId, stepId) {
    const deferred = this.$q.defer();

    this.fulfillmentRequestsService.getFulfillmentStepDefaultBranches(fulfillmentId, stepId)
      .then((res) => {
        deferred.resolve(res)
      })
      .catch((error) => {
        deferred.reject(error)
      })

    return deferred.promise

  }

  splitStepPackages(fulfillmentId, stepId, payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.splitStepPackages(fulfillmentId, stepId, payload)
      .then((res) => {
        this.fulfillmentAlertsService.splitStepPackagesSuccess();
        deferred.resolve(res)
      })
      .catch((error) => {
        this.fulfillmentAlertsService.splitStepPackagesError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise

  }


  getSteps(fulfillmentId) {
    this.bringozLoaderService.on();
    return this.fulfillmentRequestsService.getSteps(fulfillmentId)
      .catch((error) => {
        this.$log.error(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  getRelations(fulfillmentId, stepIds) {
    this.bringozLoaderService.on();
    return this.fulfillmentRequestsService.getRelations(fulfillmentId, stepIds)
      .then((relations) => {
        return relations
      })
      .catch((error) => {
        this.$log.error(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  splitStep(fulfillmentId, stepId, payload) {
    this.bringozLoaderService.on();
    return this.fulfillmentRequestsService.splitStep(fulfillmentId, stepId, payload)
      .catch((error) => {
        this.$log.error(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  getStepDispatchOption(fulfillmentId, stepId, notBefore, notAfter, suppliers) {
    this.bringozLoaderService.on();
    return this.fulfillmentRequestsService.getStepDispatchOption(fulfillmentId, stepId, notBefore, notAfter, suppliers)
      .catch((error) => {
        this.$log.error(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  // getStepDispatchTimeRanges(fulfillmentId, stepId, dispatchType, providerType, notBefore?, notAfter?, payload?, quoteType?, expandSettings?) {
  //   const deferred = this.$q.defer();
  //
  //   this.fulfillmentRequestsService.getStepDispatchTimeRanges(fulfillmentId, stepId, notBefore, notAfter, dispatchType, providerType, payload, quoteType, expandSettings)
  //     .then((res) => {
  //       deferred.resolve(res)
  //     })
  //     .catch((error) => {
  //       if (error.code === 400720 || error.code === 400721 || error.code === 400722 || error.code === 400723 || error.code === 400725) {
  //         this.fulfillmentAlertsService.getQuoteError(error.more_info)
  //       } else {
  //         this.fulfillmentAlertsService.getQuoteError();
  //       }
  //       deferred.reject(error)
  //     })
  //
  //   return deferred.promise
  //
  // }

  // let cancelToken = null;

  getStepDispatchTimeRanges(fulfillmentId, stepId, dispatchType, providerType, notBefore?, notAfter?, payload?, quoteType?, expandSettings?) {
    const requestKey = this.getStepDispatchTimeRangesRequestKey(fulfillmentId, stepId);

    if (this.cancelTokens[requestKey]) {
      this.cancelTokens[requestKey].resolve();
    }

    const cancelToken = this.$q.defer();
    this.cancelTokens[requestKey] = cancelToken;

    const deferred = this.$q.defer();

    this.fulfillmentRequestsService.getStepDispatchTimeRanges(
      fulfillmentId,
      stepId,
      notBefore,
      notAfter,
      dispatchType,
      providerType,
      payload,
      quoteType,
      expandSettings,
      cancelToken.promise
    )
      .then((res) => {
        delete this.cancelTokens[requestKey]; // Clean up
        deferred.resolve(res);
      })
      .catch((error) => {
        delete this.cancelTokens[requestKey]; // Clean up

        if (error.status === -1) {
          deferred.reject(error);
        } else {
          if ([400720, 400721, 400722, 400723, 400725].includes(error.code)) {
            this.fulfillmentAlertsService.getQuoteError(error.more_info);
          } else {
            this.fulfillmentAlertsService.getQuoteError();
          }
          deferred.reject(error);
        }
      });

    return deferred.promise;
  }

  cancelStepDispatchTimeRange(fulfillmentId, stepId) {
    const requestKey = this.getStepDispatchTimeRangesRequestKey(fulfillmentId, stepId);
    if (this.cancelTokens[requestKey]) {
      this.cancelTokens[requestKey].resolve();
      delete this.cancelTokens[requestKey];
    }
  }

  getStepDispatchTimeRangesRequestKey(fulfillmentId, stepId) {
    return `${fulfillmentId}_${stepId}`;
  }

  // dispatchStep(fulfillmentId, stepId, payload) {
  //   this.bringozLoaderService.on();
  //   return this.fulfillmentRequestsService.dispatchStep(fulfillmentId, stepId, payload)
  //     .then(() => {
  //
  //     })
  //     .catch((error) => {
  //       this.fulfillmentAlertsService.dispatchStepError(error);
  //       this.$log.error(error);
  //     })
  //     .finally(() => {
  //       this.bringozLoaderService.off();
  //     });
  // }

  dispatchStep(fulfillmentId, stepId, payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.dispatchStep(fulfillmentId, stepId, payload)
      .then((step) => {
        this.fulfillmentAlertsService.dispatchStepSuccess(true)
          .then((res) => {
            if (res) {
              const lastAttempt = _.find(step.attempts, (a) => {
                return a.referenceId === step.referenceId;
              });
              if (lastAttempt.subType === FulfillmentSubTypeType.ThirdParty) {
                const url = this.$state.href('threePLService.info', {id: lastAttempt.id});
                this.$window.open(url, '_blank');
              } else if (lastAttempt.subType === FulfillmentSubTypeType.Dispatch) {
                const url = this.$state.href('service.delivery.info', {id: lastAttempt.id});
                this.$window.open(url, '_blank');
              }
            }
          });
        deferred.resolve(step)
      })
      .catch((error) => {
        this.fulfillmentAlertsService.dispatchStepError(error);
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getFulfillmentsByPage(pageIndex, size, filter) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.getFulfillmentsByPage(pageIndex, size, filter)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getFulfillmentStepsPrice(fulfillmentId, stepIds) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.getFulfillmentStepsPrice(fulfillmentId, stepIds)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  editFulfillmentStepsPriceFactor(fulfillmentId, stepsPriceFactor) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.editFulfillmentStepsPriceFactor(fulfillmentId, stepsPriceFactor)
      .then((res) => {
        deferred.resolve(res);
        this.fulfillmentAlertsService.stepsPriceUpdateSuccess();
      })
      .catch((error) => {
        deferred.reject(error);
        this.fulfillmentAlertsService.stepsPriceUpdateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getFulfillmentsTotals(filter) {
    const deferred = this.$q.defer();

    this.fulfillmentRequestsService.getFulfillmentsTotals(filter)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })

    return deferred.promise
  }

  bulkDispatch(payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.bulkDispatch(payload)
      .then(res => {
        this.fulfillmentAlertsService.bulkDispatchSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        if (error.code !== 400414) {
          this.fulfillmentAlertsService.bulkDispatchError();
        }
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  cancelStep(fulfillmentId, stepId, cancelReason?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.cancelStep(fulfillmentId, stepId, cancelReason)
      .then(res => {
        this.fulfillmentAlertsService.cancelStepSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.fulfillmentAlertsService.cancelStepError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  exportFulfillmentSteps(payload, exportType) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.exportFulfillmentSteps(payload, exportType, this.splitService.getTimeZone())
      .then(res => {
        this.fulfillmentAlertsService.exportSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.fulfillmentAlertsService.exportError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  fulfillmentsActions(steps: FulfillmentStepModel[]) {
    let actions = {};
    const attemptActionsByStatusMap = this.FulfillmentConstants.fulfillmentStepAttemptsActionsByStatusMap;
    const stepActionsByStatusMap = this.FulfillmentConstants.fulfillmentStepActionsByStatusMap;

    const attempts = _.chain(steps)
      .filter(s => {
        return !!s.attempts
      })
      .map(s => {
        return _.find(s.attempts, attempt => {
          return attempt.id === s.referenceId;
        })
      })
      .value();

    const attemptsSubTypes = _.uniq(attempts.map(a => {
      if (a.status !== 'Canceled') {
        return a.subType;
      }
    }));

    if (attempts.length) {
      _.forOwn(this.FulfillmentConstants.fulfillmentAttemptsServiceActions, action => {
        actions[action.id] = true;
        if (action.id === 'AssignAgent' || action.id === 'AutoAssignAgent' || action.id === 'MultiAssign' ||
          action.id === 'AssignToRoute' || action.id === 'CreateRoute' || action.id === 'AssignResourceAllocation' || action.id === 'Reset') {
          if (attemptsSubTypes.includes(FulfillmentSubTypeType.ThirdParty)) {
            actions[action.id] = false;
          } else {
            _.forEach(attempts, a => {
              if (!_.includes(_.flatMap(attemptActionsByStatusMap[a.type][a.supplierStatus], 'id'), action.id)) {
                actions[action.id] = false;
              }
            })
          }
        } else {
          _.forEach(attempts, a => {
            if (a.subType === 'ThirdParty' && !_.includes(_.flatMap(attemptActionsByStatusMap['ThirdPartyService'][a.status], 'id'), action.id)) {
              actions[action.id] = false;
            } else if (a.subType !== 'ThirdParty' && !_.includes(_.flatMap(attemptActionsByStatusMap[a.type][a.supplierStatus], 'id'), action.id)) {
              actions[action.id] = false;
            }
          })
        }


      })
    }

    if (steps.length) {
      _.forOwn(this.FulfillmentConstants.fulfillmentStepsActions, action => {

        if (action.id === 'CreateVoucher') {
          let pickupDepot;
          let destinationDepot
          let canCreateVoucher = true;
          _.forEach(steps, (s) => {
            if (!!canCreateVoucher &&
              _.includes(_.flatMap(stepActionsByStatusMap[s.type][s.status], 'id'), action.id) &&
              _.isEqual(_.get(s, 'pickup.location.locationType'), LocationType.DEPOT) &&
              _.isEqual(_.get(s, 'destination.location.locationType'), LocationType.DEPOT)) {
              const pickupDepotId = _.get(s, 'pickup.location.id');
              const destinationDepotId = _.get(s, 'destination.location.id');

              if (!pickupDepot) {
                pickupDepot = pickupDepotId;
              }

              if (!destinationDepot) {
                destinationDepot = destinationDepotId;
              }

              if ((pickupDepot !== pickupDepotId || destinationDepot !== destinationDepotId)) {
                canCreateVoucher = false;
              }

            } else {
              canCreateVoucher = false;
            }
          })

          actions[action.id] = canCreateVoucher;
        } else if (action.id === 'SendToPlanning') {
          actions[action.id] = true;

          _.forEach(steps, step => {
            const lastAttempt = _.find(step.attempts, (a) => {
              return a.referenceId === step.referenceId;
            });
            if (step.status === 'Canceled' || step.status === 'Completed' || (lastAttempt && lastAttempt.status !== 'Canceled' && lastAttempt.subType === 'ThirdParty')) {
              actions[action.id] = false;
            }
          })

        } else {
          actions[action.id] = true;
          _.forEach(steps, s => {

            if (!_.includes(_.flatMap(stepActionsByStatusMap[s.type][s.status], 'id'), action.id)) {
              actions[action.id] = false;
            }

          })
        }

      })
    }

    return actions;
  }

  onForceCompleteLine(fulfillmentId, fulfillmentLineId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.onForceCompleteLine(fulfillmentId, fulfillmentLineId)
      .then(res => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error);
        this.fulfillmentAlertsService.forceCompleteLineError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  restoreFulfillment(fulfillmentId: string, copyStepTemplateId?: boolean) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.restoreFulfillment(fulfillmentId, copyStepTemplateId)
      .then((res) => {
        deferred.resolve(res);
        this.fulfillmentAlertsService.restoreFulfillmentSuccess();
      })
      .catch((error) => {
        deferred.reject(error);
        this.fulfillmentAlertsService.restoreFulfillmentError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  bulkRestoreFulfillments(payload, copyStepTemplateId?: boolean) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.fulfillmentRequestsService.bulkRestoreFulfillments(payload, copyStepTemplateId)
      .then((res) => {
        deferred.resolve(res);
        this.fulfillmentAlertsService.bulkRestoreFulfillmentSuccess();
      })
      .catch((error) => {
        deferred.reject(error);
        this.fulfillmentAlertsService.bulkRestoreFulfillmentError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getPrePickupAttemptStatuses() {
    return [this.attemptStatusType.Unassigned, this.attemptStatusType.Assigned, this.attemptStatusType.Started, this.attemptStatusType.HeadingPickup, this.attemptStatusType.ArrivedPickup];
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .service('fulfillmentService', FulfillmentService);
